import React, { useState } from "react";

import { StyledCellAction, StyledCellCommon, StyledCellTitle } from "./styles";
import { ActionsMenuForPGA } from "pages/underwriters/components/peerGroupAnalysis/ActionsMenuForPGA.js";
import { ActionsMenu } from "./ActionsMenu";
import { PencilIcon } from "../../../../assets/common/pencilIcon";
import { MediumText } from "../financialAnalysis/styles";
import { EditSubsidiaryAccountPopup } from "../../../../components/addAccountPopup/addSubAccountPopup";
import { ActionButton } from "../../../underwriterDashboard/idpDocuments/parser/styles";

export const AllClientsTable = ({
  data,
  setData,
  isMobile,
  borderRadius,
  boxShadow,
  isShortened,
  isPGA,
  isDashboard,
}) => {
  const body = (bodyData) => {
    return (
      <>
        <StyledCellTitle component={"tr"} borderRadius={borderRadius}>
          {bodyData?.AccountId}
        </StyledCellTitle>
        {!isShortened && (
          <StyledCellCommon
            component={"tr"}
            scope="row"
            borderRadius={borderRadius}
          >
            {bodyData?.CompanyName}
          </StyledCellCommon>
        )}
        <StyledCellCommon
          component={"tr"}
          scope="row"
          borderRadius={borderRadius}
        >
          {bodyData.Province !== null &&
          bodyData.Province !== undefined &&
          bodyData.Province !== "NULL"
            ? bodyData.Province
            : ""}
        </StyledCellCommon>
        <StyledCellCommon
          component={"tr"}
          scope="row"
          borderRadius={borderRadius}
        >
          {bodyData?.facount}
        </StyledCellCommon>
        <StyledCellCommon
          component={"tr"}
          scope="row"
          borderRadius={borderRadius}
        >
          {bodyData?.insightAvailable}
        </StyledCellCommon>
      </>
    );
  };

  const actions = (props) => {
    return (
      <>
        <StyledCellAction
          component={"tr"}
          scope="row"
          align="center"
          borderRadius={borderRadius}
        >
          {isPGA === true ? (
            <ActionsMenuForPGA
              client_id={props.AccountId}
              companyName={props.CompanyName}
              setData={setData}
            />
          ) : (
            <ActionsMenu
              client_id={props.AccountId}
              companyName={props.CompanyName}
              setData={setData}
            />
          )}
        </StyledCellAction>
      </>
    );
  };

  const createHeader = (title, width, align) => {
    return {
      title,
      width: width || "",
      align: align || "left",
    };
  };

  const headers = [
    createHeader("Account ID", "20%"),
    createHeader("Company Name", "25%"),
    createHeader("State/Province", "5%"),
    createHeader("# of Financial Statements", "25%"),
    createHeader("Insights", "15%"),
    createHeader(""),
  ];
  const shortenedHeaders = [
    createHeader("Account ID"),
    createHeader("Company Name"),
    createHeader(""),
    createHeader(""),
  ];

  console.log("Data: ", data);

  return (
    <div>
      {/*<ConciseTable*/}
      {/*  headers={isMobile ? "" : isShortened ? shortenedHeaders : headers}*/}
      {/*/>*/}
      {/*<ConciseTable*/}
      {/*  actions={actions}*/}
      {/*  actionType="client"*/}
      {/*  data={data}*/}
      {/*  //height="1200px"*/}
      {/*  body={body}*/}
      {/*  boxShadow={boxShadow}*/}
      {/*  borderRadius={borderRadius}*/}
      {/*  // headers={isMobile ? "" : isShortened ? shortenedHeaders : headers}*/}
      {/*/>*/}
      <TableComponent data={data} isPGA={isPGA} isDashboard={isDashboard} />
    </div>
  );
};

const TableComponent = ({ data, isPGA, isDashboard }) => {
  const headerStyle = {
    color: "grey",
    fontWeight: "bold",
  };

  const colStyles = {
    accountId: {
      minWidth: "125px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#EBE9F1",
    },
    companyName: {
      width: "300px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#EBE9F1",
    },
    state: {
      width: "150px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#EBE9F1",
    },
    financials: {
      width: "200px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#ECE9F1",
    },
    insights: {
      width: "200px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#ECE9F1",
    },
    info: {
      width: "200px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#EBE9F1",
    },
    viewSub: {
      width: "200px",
      padding: "0 16px",
      color: "#6E6B7B",
      borderColor: "#EBE9F1",
    },
  };

  const headerRowStyle = {
    display: "flex",
    padding: "15px 0",
    borderColor: "#EBE9F1",
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    border: "1px solid #EBE9F1",
    padding: "15px 0",
    backgroundColor: "white",
    borderRadius: isDashboard ? "18px" : "5px",
    boxShadow: isDashboard ? "rgba(255, 0, 0, 0.24) 0px 3px 8px;" : "none",
  };

  const [expandedAccount, setExpandedAccount] = useState(null);
  const [subsidiaryToEdit, setSubsidiaryToEdit] = useState({
    accountId: "",
    companyName: "",
    subsidiaryData: {},
  });
  const [openEditSubsidiaryPopup, setOpenEditSubsidiaryPopup] = useState(false);

  const handleEditSubsidiary = (subsidiaryData) => {
    console.log("subsidiaryData: ", subsidiaryData);

    setSubsidiaryToEdit(subsidiaryData);
    setOpenEditSubsidiaryPopup(true);
  };

  console.log("CInfo: ", data);

  return (
    <div>
      <EditSubsidiaryAccountPopup
        open={openEditSubsidiaryPopup}
        setOpen={setOpenEditSubsidiaryPopup}
        subsidiary={subsidiaryToEdit}
      />
      <div style={headerRowStyle}>
        <div style={{ ...colStyles.accountId, ...headerStyle }}>Account ID</div>
        <div style={{ ...colStyles.companyName, ...headerStyle }}>
          Account/Sub Name
        </div>
        <div style={{ ...colStyles.state, ...headerStyle }}>State/Province</div>
        <div style={{ ...colStyles.financials, ...headerStyle }}>
          # of Financials
        </div>
        {!isDashboard && (
          <div style={{ ...colStyles.insights, ...headerStyle }}>Insights</div>
        )}
        <div style={{ ...colStyles.info, ...headerStyle }}>Actions</div>
        {!isPGA && !isDashboard && (
          <div style={{ ...colStyles.viewSub, ...headerStyle }}>View Subs</div>
        )}
      </div>

      {data ? (
        data.map((row, index) => (
          <>
            <div
              key={index}
              style={{
                ...rowStyle,
                marginBottom:
                  row.SubsidiaryAccountInfo?.length > 0 &&
                  !isPGA &&
                  !isDashboard
                    ? "0"
                    : "15px",
              }}
            >
              <div style={colStyles.accountId}>{row.AccountId}</div>
              <div style={colStyles.companyName}>{row.CompanyName}</div>
              <div style={colStyles.state}>{row.Province}</div>
              <div style={colStyles.financials}>{row.count}</div>
              {!isDashboard && (
                <div style={colStyles.insights}>
                  {row.insightAvailable.map((insight) => (
                    <span key={insight}>{insight}</span>
                  ))}
                </div>
              )}
              <div style={colStyles.info}>
                {!isPGA ? (
                  <ActionsMenu
                    client_id={row.AccountId}
                    companyName={row.CompanyName}
                    subsidiaries={row.SubsidiaryAccountInfo}
                    setData={null}
                  />
                ) : (
                  <ActionsMenuForPGA
                    client_id={row.AccountId}
                    companyName={row.CompanyName}
                    setData={null}
                  />
                )}
              </div>
              {!isPGA && !isDashboard && (
                <div
                  style={{
                    ...colStyles.viewSub,
                    cursor:
                      row.SubsidiaryAccountInfo?.length > 0
                        ? "pointer"
                        : "default",
                  }}
                  onClick={() => {
                    expandedAccount === row.AccountId
                      ? setExpandedAccount(null)
                      : setExpandedAccount(row.AccountId);
                  }}
                >
                  {
                    <AnimatedChevron
                      isActive={row.SubsidiaryAccountInfo?.length > 0}
                      isExpanded={expandedAccount === row.AccountId}
                    />
                  }
                </div>
              )}
            </div>
            {!isPGA && !isDashboard && (
              <div style={{ marginBottom: "15px" }}>
                {expandedAccount === row.AccountId &&
                  row.SubsidiaryAccountInfo.map((sub, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          ...rowStyle,
                          animation: `fadeInSlideDown 0.7s ease-out ${index * 0.04}s both`,
                          opacity: 0,
                          transform: "translateY(-10px)",
                        }}
                      >
                        <div style={colStyles.accountId}>
                          {sub.SubsidiaryID}
                        </div>
                        <div style={colStyles.companyName}>
                          {sub.SubsidiaryName}
                        </div>
                        <div style={colStyles.companyName}></div>
                        <div style={colStyles.companyName}></div>
                        <div style={colStyles.companyName}></div>
                        <div
                          style={{
                            ...colStyles.companyName,
                            paddingLeft: "45px",
                          }}
                        >
                          <ActionButton
                            onClick={() =>
                              handleEditSubsidiary({
                                accountId: row.AccountId,
                                companyName: row.CompanyName,
                                ...sub,
                              })
                            }
                          >
                            <PencilIcon />
                          </ActionButton>
                        </div>
                        <div style={colStyles.companyName}></div>
                      </div>
                    );
                  })}

                {/* Add this keyframes definition to your CSS or use a styled-components global style */}
                <style>
                  {`
      @keyframes fadeInSlideDown {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}
                </style>
              </div>
            )}
          </>
        ))
      ) : (
        <MediumText>There are no accounts</MediumText>
      )}
    </div>
  );
};

export default TableComponent;

const AnimatedChevron = ({ isExpanded, isActive }) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 7 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.7s ease-in-out",
    }}
  >
    <path
      d="M1.60293 0.5C0.748577 0.5 0.287669 1.50212 0.843675 2.15079L2.95517 4.6142C3.35426 5.07981 4.07459 5.07981 4.47368 4.6142L6.58518 2.15079C7.14118 1.50212 6.68027 0.5 5.82592 0.5H1.60293Z"
      fill={isActive ? "#ff6d1d" : "#B9B9C3"}
    />
  </svg>
);
